<template>
  <div>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2" v-if="backgroundOptions.length > 1">
      <span class="wf-w-2/3 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide" v-text="text ? text : 'background'"></span>
      <div class="wf-flex wf-w-1/3">
        <button
          v-for="option in backgroundOptions"
          :key="option.key"
          @click.prevent="updateBackgroundType(option.value)"
          class="focus:wf-outline-none wf-flex-1 wf-cursor-pointer"
          :class="background[device] == option.value ? 'wf-text-blue-500' : 'wf-text-gray-500'"
        ><i class="fas" :class="option.icon"></i></button>
      </div>
    </li>
    <li v-show="background[device] == 'image'" class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-justify-between wf-items-center">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-sm wf-tracking-wide">source</span>
      <select class="wf-w-1/2 wf-text-xs" v-model="imgSrc">
        <option value="media">Media Library</option>
        <option value="external">External</option>
      </select>
    </li>
    <li v-show="background[device] == 'image' && imgSrc == 'external'" class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-justify-between wf-items-center">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-sm wf-tracking-wide">source</span>
      <input
        v-model="externalSource"
        type="text"
        class="wf-w-1/2 wf-text-right focus:wf-bg-gray-300 wf-text-xs wf-bg-gray-300 wf-text-gray-700 wf-border wf-rounded focus:wf-outline-none wf-px-2 wf-py-1"
      />
    </li>
    <li v-show="background[device] == 'image' && imgSrc == 'media'" class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-justify-between wf-items-center">
      <span class="wf-font-light wf-lowercase wf-text-gray-500 wf-text-sm wf-tracking-wide">image</span>
      <a
        href="#"
        @click.prevent="openImagesModal('backgroundImage')"
        v-if="! backgroundImage"
        class="wf-ml-auto wf-lowercase wf-text-blue-400 wf-underline wf-text-xs wf-cursor-pointer"
      >
        <i class="fas fa-image wf-mr-1"></i>select image
      </a>
      <div v-else class="wf-flex wf-items-center">
        <a href="#" class="wf-text-red-500 wf-text-xs wf-mr-1" @click.prevent="removeBackgroundImage">
          <i class="fas fa-times wf-mr-2"></i>remove
        </a>
        <div
          class="wf-cursor-pointer wf-block wf-h-8 wf-w-8 wf-border-2 wf-border-white wf-rounded-lg wf-shadow"
          style="background-position: center; background-size: cover;"
          :style="`background-image: url(${backgroundImage.image})`"
          @click.prevent="openImagesModal('backgroundImage')"
        ></div>
      </div>
    </li>
    <li v-show="background[device] == 'image'" class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-justify-between wf-items-center">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-sm wf-tracking-wide">size</span>
      <select v-model="backgroundSize" class="wf-w-1/2 wf-text-xs">
        <option value="BACKGROUND_COVER">cover</option>
        <option value="BACKGROUND_AUTO">auto</option>
        <option value="BACKGROUND_CONTAIN">contain</option>
      </select>
    </li>
    <li v-show="background[device] == 'image'" class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-justify-between wf-items-center">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-sm wf-tracking-wide">position</span>
      <select v-model="backgroundPosition" class="wf-w-1/2 wf-text-xs">
        <option value="BACKGROUND_LEFT">left</option>
        <option value="BACKGROUND_LEFT_BOTTOM">left bottom</option>
        <option value="BACKGROUND_LEFT_TOP">left top</option>
        <option value="BACKGROUND_RIGHT">right</option>
        <option value="BACKGROUND_RIGHT_BOTTOM">right bottom</option>
        <option value="BACKGROUND_RIGHT_TOP">right top</option>
        <option value="BACKGROUND_TOP">top</option>
        <option value="BACKGROUND_BOTTOM">bottom</option>
        <option value="BACKGROUND_CENTER">center</option>
      </select>
    </li>
    <li v-show="background[device] == 'image' && backgroundSize != 'bg-cover'" class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-justify-between wf-items-center">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-sm wf-tracking-wide">repeat</span>
      <select v-model="backgroundRepeat" class="wf-w-1/2 wf-text-xs">
        <option value="BACKGROUND_REPEAT">repeat</option>
        <option value="BACKGROUND_NO_REPEAT">no repeat</option>
        <option value="BACKGROUND_REPEAT_X">repeat x</option>
        <option value="BACKGROUND_REPEAT_Y">repeat y</option>
        <option value="BACKGROUND_REPEAT_ROUD">repeat round</option>
        <option value="BACKGROUND_REPEAT_SPACE">repeat space</option>
      </select>
    </li>
    <li v-show="background[device] == 'image'" class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-justify-between wf-items-center">
      <span class="wf-font-light wf-lowercase wf-text-gray-500 wf-text-sm wf-tracking-wide">fixed</span>
      <div>
        <toggle-button v-model="backgroundFixed"/>
      </div>
    </li>
    <!-- <li v-show="background == 'video'" class="flex justify-between items-center py-1">
      <span class="w-1/2">link</span>
      <input
        v-model="videoLink"
        type="text"
        class="w-1/2 focus:bg-gray-300 text-xs bg-gray-300 text-gray-700 border rounded focus:outline-none px-2 py-1"
      >
    </li>
    <li v-show="background == 'video'" class="flex justify-between items-center py-1">
      <span class="w-1/2">poster</span>
      <a
        href="#"
        @click.prevent="openImagesModal('videoPoster')"
        v-if="! videoPoster"
        class="ml-auto lowercase text-blue-400 underline text-xs cursor-pointer"
      >
        <i class="fas fa-image mr-1"></i>select image
      </a>
      <div v-else class="flex items-center">
        <a href="#" class="text-red-500 text-xs mr-1" @click.prevent="removeVideoPoster">
          <i class="fas fa-times mr-2"></i>remove
        </a>
        <div
          class="cursor-pointer block h-8 w-8 border-2 border-white rounded-lg shadow"
          style="background-position: center; background-size: cover;"
          :style="`background-image: url(${videoPoster})`"
          @click.prevent="openImagesModal('videoPoster')"
        ></div>
      </div>
    </li> -->
    <!-- <li v-show="background[device] == 'image' || background == 'video'" class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-justify-between wf-items-center">
      <span class="wf-font-light wf-lowercase wf-text-gray-500 wf-text-sm wf-tracking-wide">overlay</span>
      <div>
        <toggle-button sync v-model="overlay"/>
      </div>
    </li> -->
    <li v-show="background[device] == 'color' && false" class="wf-flex wf-justify-between wf-py-1">
      <span
        class="wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide"
        v-text="backgroundOptions.length > 1 ? 'gradient' : 'background gradient'"
      ></span>
      <div>
        <toggle-button sync v-model="gradient[device]"/>
      </div>
    </li>
    <li v-show="background[device] == 'color' && gradient[device] && false" class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">type</span>
      <div class="wf-flex wf-w-1/2">
        <button
          @click.prevent="gradientType[device] = 'linear'"
          class="focus:wf-outline-none wf-flex-1 wf-cursor-pointer"
          :class="gradientType[device] == 'linear' ? 'wf-text-blue-500' : ''"
        >linear</button>
        <button
          @click.prevent="gradientType[device] = 'radial'"
          class="focus:wf-outline-none wf-flex-1 wf-cursor-pointer"
          :class="gradientType[device] == 'radial' ? 'wf-text-blue-500' : ''"
        >radial</button>
      </div>
    </li>
    <li v-show="background[device] == 'color' && gradient[device] && gradientType[device] == 'linear' && false" class="wf-flex wf-justify-between wf-py-1">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">angle</span>
      <span class="wf-w-1/2">
        <vue-slider
          ref="size-slider"
          v-model="gradientAngle[device]"
          :interval="1"
          :min="0"
          :max="360"
          adsorb
          tooltip="none"
          :duration="0"
        ></vue-slider>              
      </span>
    </li>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-justify-between wf-items-center">
      <span
        class="wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide "
        v-text="gradient[device] ? 'from color' : backgroundOptions.length > 1 ?  'color' : text ? text : 'background color'"
      ></span>
      <EditorPicker picker-classes="wf-top-0 wf-mt-8 wf-right-0" :value="fromColor[device]" @input="updateFromColor"/>
    </li>
    <li v-show="background[device] == 'color' && gradient[device] && false" class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-justify-between wf-py-2 wf-items-center">
      <span
        class="wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide"
        v-text="'to color'"
      ></span>
      <EditorPicker picker-classes="wf-top-0 wf-mt-8 wf-right-0" :value="toColor[device]" @input="updateToColor"/>
    </li>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { BackgroundColorStyle } from '../styles/ColorStyles'
  import { BackgroundPositionClasses, BackgroundRepeatClasses, BackgroundSizeClasses } from '../classes/BackgroundClasses'
  import EditorPicker from '../components/EditorPicker'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  export default MenuStyleProperty.extend({
    components: {EditorPicker},
    data() {
      return {
        imgSrc: 'media',
        externalSource: '',
        gradient: {
          phone: false,
          tablet: false,
          desktop: false
        },
        gradientType: {
          phone: 'linear',
          tablet: 'linear',
          desktop: 'linear',
        },
        gradientAngle: {
          phone: 0,
          tablet: 0,
          desktop: 0,
        },
        fromColor: {
          phone: '#ffffff',
          tablet: '#ffffff',
          desktop: '#ffffff',
        },
        toColor: {
          phone: '#ffffff',
          tablet: '#ffffff',
          desktop: '#ffffff',
        }
      }
    },
    watch: {
      externalSource() {
        this.updateBackground()
      },
      background(value, oldValue) {
        if (value == oldValue) {
          return
        }
        if (value[this.device] == 'video') {
          this.fromColor[this.device] = 'rgba(0,0,0,0)'
          this.toColor[this.device] = 'rgba(0,0,0,0)'
        }
        if (value[this.device] == 'image') {
          this.fromColor[this.device] = 'rgba(0,0,0,0)'
          this.toColor[this.device] = 'rgba(0,0,0,0)'
        }
        this.updateBackground()
      },
      backgroundImage() {

        this.updateBackground()
      },
      gradientAngle() {
        this.updateBackground()
      },
      gradient(value) {
        if (! value) {
          this.toColor[this.device] = this.fromColor[this.device]
        }
      },
      gradientType() {
        this.updateBackground()
      },
    },
    computed: {
      backgroundOptions() {
        let options = [
          { key: 'color', value: 'color', icon: 'fa-paint-brush' },
          { key: 'image', value: 'image', icon: 'fa-image' },
          // { key: 'video', value: 'video', icon: 'fa-video' },
        ]
        if (this.only.length) {
          options = options.filter(option => this.only.includes(option.value))
        }
        return options
      },
      positionClasses() {
        return Object.keys(BackgroundPositionClasses)
      },
      repeatClasses() {
        return Object.keys(BackgroundRepeatClasses)
      },
      sizeClasses() {
        return Object.keys(BackgroundSizeClasses)
      },
      backgroundRepeat: {
        get() {
          let repeat = this.elementClasses(this.classes)[this.device].find(elementClass => this.repeatClasses.includes(elementClass.value))
          if (! repeat) {
            repeat = {property:'BackgroundRepeat', value: 'BACKGROUND_REPEAT', touched: false}
            this.addToArray(this.module, [repeat], this.classes, this.device, {}, true, this.parentModule)
          }
          return repeat.value
        },
        set(value) {
          let currentPosition = this.elementClasses(this.classes)[this.device].find(elementClass => this.repeatClasses.includes(elementClass.value))
          value = {property: 'BackgroundRepeat', value: value, touched: currentPosition.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }
      },
      backgroundPosition: {
        get() {
          let position = this.elementClasses(this.classes)[this.device].find(elementClass => this.positionClasses.includes(elementClass.value))
          if (! position) {
            position = {property: 'BackgroundPosition', value: 'BACKGROUND_CENTER', touched: false}
            this.addToArray(this.module, [position], this.classes, this.device, {}, true, this.parentModule)
          }
          return position.value
        },
        set(value) {
          let currentPosition = this.elementClasses(this.classes)[this.device].find(elementClass => this.positionClasses.includes(elementClass.value))
          value = {property: 'BackgroundPosition', value: value, touched: currentPosition.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }
      },
      backgroundSize: {
        get() {
          let size = this.elementClasses(this.classes)[this.device].find(elementClass => this.sizeClasses.includes(elementClass.value))
          if (! size) {
            size = {property: 'BackgroundSize', value: 'BACKGROUND_COVER', touched: false}
            this.addToArray(this.module, [size], this.classes, this.device, {}, true, this.parentModule)
          }
          return size.value
        },
        set(value) {
          let currentSize = this.elementClasses(this.classes)[this.device].find(elementClass => this.sizeClasses.includes(elementClass.value))
          value = {property: 'BackgroundSize', value: value, touched: currentSize.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }
      },
      backgroundFixed: {
        get() {
          return !! this.elementClasses(this.classes)[this.device].find(elementClass => elementClass.value == 'BACKGROUND_FIXED')
        },
        set(value) {
          if (value) {
            let backgroundFixed = {property: 'BackgroundFixed', value: 'BACKGROUND_FIXED', touched: false}
            return this.addToArray(this.module, [backgroundFixed], this.classes, this.device, {}, true, this.parentModule)
          }
          let backgroundFixed = {property: 'BackgroundFixed', value: 'BACKGROUND_SCROLL', touched: false}
          this.addToArray(this.module, [backgroundFixed], this.classes, this.device, {}, true, this.parentModule)
        }
      },
      background() {
          return this.$store.getters[`${this.module}/background`](this.element, this.parentModule)
      },
      // video() {
      //   return this.elementAssets[this.device].find(asset => Object.prototype.hasOwnProperty.call(asset, 'video'))
      // },
      backgroundImage() {
        return this.elementAssets[this.device].find(asset => asset.element == 'backgroundImage')
      },
      // videoPoster() {
      //   return this.video ? this.video.poster : null
      // },
      // videoLink: {
      //   get() {
      //     return this.video ? this.video.video : null
      //   },
      //   set: _.debounce(function (value) {
      //     let videoPoster = this.videoPoster
      //     if (this.video) {
      //       this.removeFromArray(this.module, [this.video], 'assets')   
      //     }
      //     this.addToArray(this.module, [{video: value, poster: videoPoster}], 'assets')
      //   }, 1000)
      // },
    },
    methods: {
      updateBackgroundType(value) {
        let background = new Object({...this.background})
        this.$set(background, this.device, value)
        this.addToObject(this.module, {background}, 'base', {}, true, this.parentModule)
      },
      updateFromColor(value) {
        if (typeof(value) == 'object') {
            this.$set(this.fromColor, this.device, `rgba(${value.rgba.r}, ${value.rgba.g}, ${value.rgba.b}, ${value.rgba.a})`)
        }
        this.updateBackground()
      },
      updateToColor(value) {
        if (typeof(value) == 'object') {
          this.$set(this.toColor, this.device, `rgba(${value.rgba.r}, ${value.rgba.g}, ${value.rgba.b}, ${value.rgba.a})`)
        }
        this.updateBackground()
      },
      updateBackground: _.debounce(function () {
        let fromColor = this.fromColor[this.device]
        let toColor = this.fromColor[this.device]
        let gradientAngle = `${this.gradientAngle[this.device]}deg`
        if (this.gradient[this.device]) {
          toColor = this.toColor[this.device]
        }
        if (this.gradientType[this.device] == 'radial') {
          gradientAngle = 'circle'
        }
        let background = `${this.gradientType[this.device]}-gradient(${gradientAngle}, ${fromColor}, ${toColor})`
        if (this.background[this.device] == 'image' && this.backgroundImage) {
          background += `, url(${this.backgroundImage.image})`
        }
        if (this.background[this.device] == 'image' && this.externalSource) {
          background += `, url('${this.externalSource}')`
        }
        let backgroundStyle = {...BackgroundColorStyle, value: background, touched: false}
        this.addToArray(this.module, [backgroundStyle], this.styles, this.device, {}, true, this.parentModule)
      }, 500),
      removeBackgroundImage() {
        if (! this.backgroundImage) {
          return
        }
        this.removeFromArray(this.module, [this.backgroundImage], 'assets', this.device)
      },
      // removeVideoPoster() {
      //   if (! this.videoPoster) {
      //     return
      //   }
      //   let video = this.video
      //   this.removeFromArray(this.module, [this.video], 'assets')
      //   this.addToArray(this.module, [{video: video.video, poster: ''}], 'assets')
      // },
      openImagesModal(element) {
        this.$modal.show('imagesModal', {
          ...this.element,
          currentImage: this.backgroundImage,
          module: this.module,
          element: element,
          device: this.device,
          video: this.video
        })
      },
    },
  })
</script>